export const PULSAR_COMPANIES = [
  {
    id: "qsr-food",
    name: "QSR Food Platform",
    sector: "Food & Beverage",
    headcount: 2200,
    asbc_gap: 8500000,
    labour_cost: 32000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/qsr-platform-pulsar-2026",
    signal: "red",
    urgency_reason: "Rapid multi-brand expansion creating org design gaps",
    functions: ["Store Operations", "Supply Chain", "Technology", "Marketing", "Finance", "HR & People"],
    competitors: [
      { name: "QSR Food Platform", score: 34, isTarget: true },
      { name: "Jubilant FoodWorks", score: 68 },
      { name: "Devyani International", score: 58 },
      { name: "Westlife Foodworld", score: 52 },
      { name: "Burger King India", score: 48 },
    ],
    velocity_headline: "Multi-brand expansion outpacing workforce design",
    leadership_scores: [5, 4, 5, 4, 4, 5, 5],
    readiness_score: 66,
    readiness_drivers: [
      "Rapid expansion creating duplicated roles across brands",
      "Store operations workforce at highest BOT potential",
      "Supply chain structuring needed before next growth phase",
    ],
  },
  {
    id: "asiri-hospitals",
    name: "Asiri Hospitals",
    sector: "Healthcare",
    headcount: 6500,
    asbc_gap: 18000000,
    labour_cost: 68000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/asiri-hospitals-pulsar-2026",
    signal: "amber",
    urgency_reason: "Clinical workforce optimisation opportunity",
    functions: ["Clinical Operations", "Nursing", "Administration", "Technology", "Finance", "HR & People"],
    competitors: [
      { name: "Asiri Hospitals", score: 42, isTarget: true },
      { name: "Nawaloka Hospitals", score: 48 },
      { name: "Lanka Hospitals", score: 52 },
      { name: "IHH Healthcare", score: 68 },
      { name: "Apollo Hospitals", score: 72 },
    ],
    velocity_headline: "Clinical AI adoption lagging regional benchmarks",
    leadership_scores: [6, 7, 4, 4, 5, 6, 6],
    readiness_score: 52,
    readiness_drivers: [
      "Administration function over-resourced vs regional peers",
      "Clinical operations present moderate automation opportunity",
      "Strong tenure stability offsets digital capability gap",
    ],
  },
  {
    id: "gcc-tech",
    name: "India-GCC Tech Venture",
    sector: "Technology",
    headcount: 800,
    asbc_gap: 4200000,
    labour_cost: 18000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/gcc-tech-pulsar-2026",
    signal: "green",
    urgency_reason: "Strong digital team — scale efficiently",
    functions: ["Engineering", "Product", "Sales", "Operations", "Finance", "HR & People"],
    competitors: [
      { name: "India-GCC Tech Venture", score: 64, isTarget: true },
      { name: "Careem (tech arm)", score: 72 },
      { name: "Kitopi", score: 68 },
      { name: "Property Finder Tech", score: 58 },
      { name: "Tabby", score: 74 },
    ],
    velocity_headline: "Strong digital base — focus on scaling efficiency",
    leadership_scores: [7, 5, 7, 7, 5, 6, 6],
    readiness_score: 36,
    readiness_drivers: [
      "Already tech-forward — optimisation over transformation",
      "Small team enables rapid structure changes",
      "GCC expansion creating moderate org design stretch",
    ],
  },
  {
    id: "finserv-co",
    name: "Financial Services Co",
    sector: "Financial Services",
    headcount: 1500,
    asbc_gap: 6800000,
    labour_cost: 28000000,
    currency: "USD",
    demo_url: "https://app.reaimagination.com/demo/finserv-pulsar-2026",
    signal: "amber",
    urgency_reason: "Compliance function over-resourced vs sector peers",
    functions: ["Operations", "Compliance & Risk", "Technology", "Client Services", "Finance", "HR & People"],
    competitors: [
      { name: "Financial Services Co", score: 40, isTarget: true },
      { name: "Standard Chartered GCC", score: 62 },
      { name: "Mashreq Bank", score: 56 },
      { name: "RAKBANK", score: 48 },
      { name: "Emirates NBD", score: 68 },
    ],
    velocity_headline: "Compliance function 18% above sector benchmark",
    leadership_scores: [6, 6, 5, 5, 5, 6, 6],
    readiness_score: 48,
    readiness_drivers: [
      "Compliance and risk functions over-staffed vs optimal",
      "Technology modernisation creating restructuring window",
      "Client services automation opportunity moderate",
    ],
  },
];
